<template>
  <div class="footer">
      <div class="mr-auto flex flexa flexb pdt25 pdb30" :class="language == 'EN'?'wth1400':'wth1200'">
        <!-- <div class="wth300 tc" v-if="language == 'EN'">
          <img src="@/assets/images/logo.png" class="logo">
          <div class="mt10">
       
            <img :src="footer.qrcode.cover_img" width="100%">
          </div>
        </div>v-else -->
        <div class="wth330 tc" >
          <img src="@/assets/images/logo.png" class="logo">
          <div class="mt20">
            <!--<img src="@/assets/images/ewm.png">-->
            <img :src="footer.qrcode.cover_img">
          </div>
        </div>
        <!-- blc -->
        <div class=" flex flexe" :class="language == 'EN'?'wth1000  mt20':'wth900'" >
          <div class=" flex flexe" v-for="(item,index) in menu_list" :key="index">
            <div class="foot_nav" :style="language == 'EN' ? 'padding: 0 13px;': 'padding: 0 25px;'">
              <div class="black fb mb5" style="white-space:nowrap">{{item.title}}</div>
              <div class="gray lh25 f15" style="white-space:nowrap"  v-for="(iitem,i) in item.child" :key="i" @click="goUrl(item.href,i+1,iitem.func)">
                <template v-if="iitem.func == 'Dalian' && language == 'CH'">
                    大连中远
                </template>
                <template v-else>
                  {{iitem.title}}
                </template>
              </div>

            </div>
            <div class="foot_dot" v-if="index < menu_list.length - 1"></div>
          </div>
          <!--
          <div class="foot_nav" v-for="(item,index) in menu_list" :key="index">
            <div class="black fb mb5">{{language == 'EN'?'About Us':'关于我们'}}</div>
            <div class="gray lh25 f15" @click="goUrl('about',1)">{{language == 'EN'?'Company Profile':'企业概况'}}</div>
            <div class="gray lh25 f15" @click="goUrl('about',2)">{{language == 'EN'?'Business Leaders':'企业领导'}}</div>
            <div class="gray lh25 f15" @click="goUrl('about',3)">{{language == 'EN'?'Corporate Culture':'企业文化'}}</div>
            <div class="gray lh25 f15" @click="goUrl('about',4)">{{language == 'EN'?'Leading Care':'发展历程'}}</div>
            <div class="gray lh25 f15" @click="goUrl('about',5)">{{language == 'EN'?'Leading Care':'领导关怀'}}</div>
            <div class="gray lh25 f15" @click="goUrl('about',6)">{{language == 'EN'?'Honor':'资质荣誉'}}</div>
          </div>
          <div class="foot_dot"></div>


          <div class="foot_nav">
            <div class="black fb mb5">{{language == 'EN'?'News Center':'新闻中心'}}</div>
            <div class="gray lh25 f15" @click="goUrl('news',1)">{{language == 'EN'?'Company News':'企业新闻'}}</div>
            <div class="gray lh25 f15" @click="goUrl('news',2)">{{language == 'EN'?'Industry News':'行业动态'}}</div>
            <div class="gray lh25 f15" @click="goUrl('news',3)">{{language == 'EN'?'Announcement':'通知公告'}}</div>
          </div>
          <div class="foot_dot"></div>
          <div class="foot_nav">
            <div class="black fb mb5">{{language == 'EN'?'Business':'经营领域'}}</div>
            <div class="gray lh25 f15" @click="goUrl('business',1)">{{language == 'EN'?'Vessels Repaired':'修造与改装'}}</div>
            <div class="gray lh25 f15" @click="goUrl('business',2)">{{language == 'EN'?'Successful Case':'经典案例'}}</div>
          </div>
          <div class="foot_dot"></div>
          <div class="foot_nav">
            <div class="black fb mb5">{{language == 'EN'?'Facilities':'设施设备'}}</div>
            <div class="gray lh25 f15" @click="goUrl('facilities',1)">{{language == 'EN'?'Dry-Dock':'船坞介绍'}}</div>
            <div class="gray lh25 f15" @click="goUrl('facilities',2)">{{language == 'EN'?'Outfitting Quay':'舾装码头'}}</div>
            <div class="gray lh25 f15" @click="goUrl('facilities',3)">{{language == 'EN'?'Glimpse':'车间掠影'}}</div>
            <div class="gray lh25 f15" @click="goUrl('facilities',4)">{{language == 'EN'?'Facilities':'主要设备'}}</div>
          </div>
          <div class="foot_dot"></div>
          <div class="foot_nav">
            <div class="black fb mb5">{{language == 'EN'?'Join Us':'人力资源'}}</div>
            <div class="gray lh25 f15" @click="goUrl('resources',1)">{{language == 'EN'?'Strategy':'人才战略'}}</div>
            <div class="gray lh25 f15" @click="goUrl('resources',2)">{{language == 'EN'?'Recruit':'人才招聘'}}</div>
          </div>
          <div class="foot_dot"></div>
          <div class="foot_nav" style="padding-right:0;">
            <div class="black fb mb5">{{language == 'EN'?'Contact':'联系我们'}}</div>
            <div class="gray lh25 f15" @click="goUrl('contact',1)">{{language == 'EN'?'Contact':'联系信息'}}</div>
            <div class="gray lh25 f15" @click="goUrl('contact',2)">{{language == 'EN'?'Messages':'在线留言板'}}</div>
            <div class="gray lh25 f15" @click="goUrl('contact',3)">{{language == 'EN'?'Mailbox':'总裁信箱'}}</div>
          </div>
          -->
        </div>

      </div>

      <div class="btc">
        <div class="wth1200 mr-auto flex flexa flexb pdt25 pdb25">
          <div>
            <div class="f16 lh30">{{language == 'EN'?'Contact Number':'联系电话'}}</div>
            <div class="f36 fb dblue mt10">{{footer.phone.info}}</div>
          </div>

          <div class="f16 lh30">
              {{footer.address.title}}：{{footer.address.info}}　&nbsp;&nbsp;&nbsp;
              {{footer.fax.title}}：{{footer.fax.info}} <br>
              {{footer.email.title}}：{{footer.email.info}}　<br>
              {{footer.copyright.info}}
              <a target="_blank" href="https://beian.miit.gov.cn/">浙ICP备11005702号-1</a>

              <!--
              {{language == 'EN'?'Address：LongShanShaAo Village, Liuheng Island, Zhoushan City':'公司地址：舟山市普陀区六横镇龙山沙岙村'}}　&nbsp;&nbsp;&nbsp;
              {{language == 'EN'?'Fax':'传真'}}：0086-580-6688098<br>
              {{language == 'EN'?'E-mail':'邮箱'}} ：Business@Ls-shipyard.com<br>

              Copyright &copy; 2008-2023
              {{language == 'EN'?'Zhoushan Longshan Shipyard Co., Ltd':'舟山市龙山船厂有限公司'}}
              &nbsp;&nbsp;&nbsp;ALL RIGHTS RESERVED
              -->
          </div>

        </div>

      </div>
  </div>
</template>

<script>
import {getFooter, getCompanyConfig} from "@/request/api";
export default {
  name: 'Footer',
  data () {
    return {
      language:localStorage.getItem('language') || 'CH',
      menu_list:[],
      footer:[],
    }
  },
  created (){
    this.getFooter()
  },
  methods:{
    getFooter(){
      var that = this
      getFooter().then(res=>{
        that.menu_list = res.data.menu
      }).catch(function (error) {
          console.log(error);
      });

      getCompanyConfig().then(res=>{
        that.footer = res.data
      }).catch(function (error) {
          console.log(error);
      });
    },
    goUrl(url,t,f){
      this.$router.push({ path: '/'+url, query: { tab:t,func:f} });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
  width: 100%;
  background: #fff url(../assets/images/bg_bot.png) no-repeat bottom center;
  background-size: 100% 100%;
}
.logo{
  width: 330px;
}
.foot_nav{
  padding: 0 25px;
  font-size: 16px;
  text-align: center;
}
.foot_nav .gray{
  cursor: pointer;
}
.foot_dot{
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin-top: 8px;
  background-color: #1C4383;

}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue